import React from 'react';
import type { DefaultSegmentTemplate } from '../default-segment-templates';
import { SegmentTemplateCard } from './SegmentTemplateCard';
import styles from './CreateSegmentDialog.module.css';

interface TemplateListProps {
  templates: DefaultSegmentTemplate[];
  onSelectTemplate: (templateName: string) => void;
}

export const TemplateList: React.FC<TemplateListProps> = ({
  templates,
  onSelectTemplate,
}) => {
  return (
    <ul className={styles.templateList}>
      {templates.map(template => (
        <li key={template.name}>
          <SegmentTemplateCard
            template={template}
            onSelect={onSelectTemplate}
          />
        </li>
      ))}
    </ul>
  );
};
